import { Card } from "@/components/ui/card";
import chilisLogo from "@/assets/clients/chilis.png";
import jollibee from "@/assets/clients/jollibee.png";
import sheratonLogo from "@/assets/clients/sheraton.png";
import mediamarktLogo from "@/assets/clients/mediamarkt.png";
import carrefourLogo from "@/assets/clients/carrefour.png";
import dunkinLogo from "@/assets/clients/dunkin.png";
import panasonicLogo from "@/assets/clients/panasonic.png";
import cocacolaLogo from "@/assets/clients/cocacola.png";
import marriottLogo from "@/assets/clients/marriott.png";
import pizzahutLogo from "@/assets/clients/pizzahut.png";
import shellLogo from "@/assets/clients/shell.png";
import quiktripLogo from "@/assets/clients/quiktrip.png";
import walmartLogo from "@/assets/clients/walmart.png";

const GlobalClients = () => {
  const clients = [
    { name: "Chili's", logo: chilisLogo },
    { name: "MediaMarkt", logo: mediamarktLogo },
    { name: "Carrefour", logo: carrefourLogo },
    { name: "Dunkin'", logo: dunkinLogo },
    { name: "Panasonic", logo: panasonicLogo },
    { name: "Coca-Cola", logo: cocacolaLogo },
    { name: "Jollibee", logo: jollibee },
    { name: "Marriott", logo: marriottLogo },
    { name: "Pizza Hut", logo: pizzahutLogo },
    { name: "Shell", logo: shellLogo },
    { name: "QuikTrip", logo: quiktripLogo },
    { name: "Walmart", logo: walmartLogo }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-background via-muted/20 to-background">
      <div className="text-center mb-12">
        <h2 className="font-orbitron font-bold text-4xl md:text-5xl mb-4">
          Businesses Grow with <span className="text-primary">Pudu Robotics</span>
        </h2>
        <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
          Join thousands of businesses worldwide that have transformed their operations with our robotics solutions
        </p>
      </div>

      <div className="mb-12">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {clients.map((client, idx) => (
            <Card 
              key={idx} 
              className="bg-card border-border hover:shadow-lg transition-all duration-300 p-8 flex items-center justify-center min-h-[120px]"
            >
              <img 
                src={client.logo} 
                alt={`${client.name} logo`}
                className="max-w-full max-h-16 w-auto h-auto object-contain"
              />
            </Card>
          ))}
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-6 text-center">
        <Card className="glass-effect border-[hsl(var(--line))] p-6">
          <div className="text-4xl font-orbitron font-bold text-primary mb-2">60,000+</div>
          <p className="text-sm text-muted-foreground">Robots Deployed Worldwide</p>
        </Card>
        <Card className="glass-effect border-[hsl(var(--line))] p-6">
          <div className="text-4xl font-orbitron font-bold text-primary mb-2">120+</div>
          <p className="text-sm text-muted-foreground">Countries & Regions</p>
        </Card>
        <Card className="glass-effect border-[hsl(var(--line))] p-6">
          <div className="text-4xl font-orbitron font-bold text-primary mb-2">2,000+</div>
          <p className="text-sm text-muted-foreground">Enterprise Clients</p>
        </Card>
      </div>
    </section>
  );
};

export default GlobalClients;
